import { comicCategories } from "@/mocks/comics";

export default function Categories() {
  return (
    <section id="category" className="relative py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 text-center md:mb-14">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-400">
            <i className="ri-grid-line"></i>
            全部分类
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
            海量分类，<span className="text-gradient-gold">想看的都有</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-400">
            从都市豪门到热血战斗，从逆袭打脸到甜宠恋爱，六大热门分类持续更新，满足不同口味的阅读需求。
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {comicCategories.map((cat) => (
            <a
              key={cat.name}
              href="#hot"
              className="group relative flex items-center gap-4 overflow-hidden rounded-lg border border-background-600/60 bg-background-900/60 p-5 transition-all duration-300 hover:border-primary-600/70 hover:bg-background-800/60 md:p-6"
            >
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-md bg-primary-500/15 text-2xl text-primary-400 transition-colors group-hover:bg-primary-500 group-hover:text-background-950">
                <i className={cat.icon}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-semibold text-foreground-50">{cat.name}</h3>
                  <span className="rounded bg-secondary-500/15 px-1.5 py-0.5 text-[10px] text-secondary-300">
                    {cat.count} 部
                  </span>
                </div>
                <p className="mt-1 truncate text-xs text-foreground-400">{cat.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line ml-auto text-xl text-foreground-500 transition-transform group-hover:translate-x-1 group-hover:text-primary-400"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}